const styles = (theme) => ({
	// Painel lateral: ocupa a tela inteira no mobile e uma coluna fixa no
	// desktop. Coluna flex para o corpo rolar sozinho entre cabeçalho e rodapé.
	paper: {
		width: { xs: "100%", sm: 640, md: 800 },
		maxWidth: "100vw",
		display: "flex",
		flexDirection: "column",
		backgroundImage: "none",
	},
	cabecalho: {
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "space-between",
		gap: 2,
		p: 2,
		pb: 1.5,
	},
	titulo: {
		fontSize: "1.15rem",
		fontWeight: 600,
		color: "text.primary",
	},
	subtitulo: {
		color: "text.secondary",
		fontSize: "0.85rem",
	},
	corpo: {
		flexGrow: 1,
		minHeight: 0,
		overflowY: "auto",
		p: 2,
	},
	rodape: {
		display: "flex",
		justifyContent: "flex-end",
		gap: 1,
		p: 2,
	},
	resultadoTeste: {
		mt: 1,
		p: 1.5,
		bgcolor: "action.hover",
		borderRadius: 1,
		fontSize: 12,
		maxHeight: 220,
		overflow: "auto",
		whiteSpace: "pre-wrap",
	},
});

export default styles;
